import type { RadioButtonPropsType } from './types';

const RadioButton: React.FC<RadioButtonPropsType> = (props: RadioButtonPropsType) => {
  return (
    <label className="relative inline-flex justify-start items-center m-2 cursor-pointer [&>input:checked+span]:before:bg-accent">
      <input className="absolute invisible" type="radio" name={props.name} value={props.value} checked={props.checked} onChange={props.onChange} />
      <span className="inline-flex justify-center items-center w-8 h-8 p-1.5 mr-2 rounded-full border border-black bg-white before:content-[''] before:block before:w-full before:h-full before:rounded-full before:bg-white" />
      {props.label}
    </label>
  );
};

export { RadioButton };
